import React from 'react';
import { useChatbot } from '../../context/ChatbotContext';
import { AIConfigTab } from '../../components/chatbot/tabs/AIConfigTab';

const ChatbotConfigPage: React.FC = () => {
  const { account, setAccount } = useChatbot();
  return <AIConfigTab account={account} onUpdated={setAccount} />;
};

export default ChatbotConfigPage;
